'use client';

import { useMemo } from 'react';

import { Text, TextLevels, TextMarkup, TypographyBold } from '@bytel/trilogy-react';

import { MobilePlanDetailWithProvenanceType, MobilePlanProvenanceType } from '@app-types/plan';

type PlanSubtitleProps = {
    planWithProvenance?: MobilePlanDetailWithProvenanceType;
};

export function PlanSubtitle({ planWithProvenance }: Readonly<PlanSubtitleProps>) {
    const plan = planWithProvenance?.plan;
    const isOwnedPlan = useMemo(
        () => planWithProvenance?.origin === MobilePlanProvenanceType.OWNED,
        [planWithProvenance],
    );

    if (!plan) {
        return (
            <Text level={TextLevels.THREE} marginless>
                Sans forfait
            </Text>
        );
    }

    return (
        <Text level={TextLevels.THREE} marginless>
            {isOwnedPlan ? 'Votre forfait actuel\u00A0:' : 'Avec le forfait'}{' '}
            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.THREE} markup={TextMarkup.SPAN}>
                {plan.name}
            </Text>
        </Text>
    );
}
